var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7016 24.226C46.7016 31.322 43.4428 37.6638 38.3387 41.8306C34.4282 45.0162 29.4413 46.9274 24.0002 46.9274C11.4632 46.9274 1.29883 36.763 1.29883 24.226C1.29883 19.4221 2.79264 14.977 5.33383 11.3082C9.43464 5.3986 16.2671 1.52466 24.0002 1.52466C36.5372 1.52466 46.7016 11.6963 46.7016 24.226Z",
    fill: "#64D4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7016 24.2258C46.7016 31.3217 43.4428 37.6635 38.3387 41.8304C34.4282 45.016 29.4413 46.9272 24.0002 46.9272C11.4632 46.9272 1.29883 36.7628 1.29883 24.2258C1.29883 19.4219 2.79264 14.9768 5.33383 11.308C9.43464 5.39835 16.2671 1.52441 24.0002 1.52441C36.5372 1.52441 46.7016 11.6961 46.7016 24.2258Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7155 24.4578L27.5126 27.7204L21.7582 36.7553C20.836 38.2034 18.6092 37.7169 18.3748 36.0163L15.4324 14.6686C15.2377 13.2554 16.6521 12.1654 17.9691 12.7137L37.8629 20.9977C39.4476 21.6576 39.3506 23.9348 37.7155 24.4578Z",
    fill: "#F7A294"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.3abeab642817223e3335d9900b7a1358.svg";
export { ForwardRef as ReactComponent };